const getDefaultState = () => {
  return {
    hasMultipleVendors: false
  }
}

// initial state
const state = getDefaultState()

// mutations
const mutations = {
  hasMultipleVendorsAssign (state, bool) {
    state.hasMultipleVendors = bool
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/js/store/modules/shop.js